<oa-input [value]="value" class="oa-input-group sm" (changed)="onBlur($event)" [readonly]="readonly"
  [disabled]="disabled"></oa-input>
